// Formatting locale. Times are shown in WIB: the backend's business day and Surat Jalan month are WIB.

export const LOCALE = 'id-ID';
export const TIME_ZONE = 'Asia/Jakarta';
/** WIB as a UTC offset (no daylight saving): the start of a WIB day as an instant. */
export const WIB_OFFSET = '+07:00';
/** App name until /meta answers (the backend's APP_NAME wins). */
export const FALLBACK_APP_NAME = 'Monitoring CNG Merah Putih';
/** The short product name next to the emblem in the rail (the full APP_NAME stays in the tab title and on the login). */
export const BRAND_SHORT = 'CNG Merah Putih';
/** Copyright holder on the login page (the system belongs to the ministry; ORG_NAME is the Surat Jalan issuer). */
export const COPYRIGHT_HOLDER = 'Kementerian ESDM Republik Indonesia';
